import React, {Component} from "react";
import {connect} from "react-redux";

import "./ClusterGroupTabs.css";

class ClusterGroupTabs extends Component {

  constructor(props) {
    super(props);
    this.state = {
      hidden: false,
      activeTab: 'dgh',
      options: [
        {slug: 'dgh', name: 'Dynamic growth hubs', img:''},
        {slug: 'se', name: 'Stable Economies', img:''},
        {slug: 'sr', name: 'Shrinking regions', img:''}
      ]
    }
    this.onClickTab = this.onClickTab.bind(this);
  }

  componentDidMount() {

  }

  componentWillUnmount() {

  }

  onClickTab(view, e){
    e.preventDefault();
    this.setState({activeTab: view.slug});
    //this.props.history.push(tabUrl);
  }

  render() {
    const {children} = this.props;
    const {activeTab, options} = this.state;
    return (
      <div>
        <div className="fow-cluster-group-tabs-placeholder">
          <div className="fow-cluster-group-tabs">
            <div className="fow-inner-container">
              <ul className="fow-view-subnav fow-row">
                {
                  options.map((view)=>
                    <li key={view.slug}>
                      <a href={`#${view.slug}`} className={`fow-cluster-group-tabs-item fow-cluster-group-tabs-item-full ${(activeTab === view.slug) ? 'fow-cluster-group-tabs-item-selected' : ''}`} onClick={(e) => this.onClickTab(view, e)}>
                        <span className="fow-cluster-group-tabs-label fow-font-text fow-font-size-md">{view.name}</span>
                      </a>
                    </li>
                  )
                }
              </ul>
            </div>
          </div>
        </div>
        <div className="fow-inner-container">
          <div className="fow-row fow-cluster-group-tabs-content-container">
            {
              options[0].slug === activeTab &&
              <>{children[0]}</>
            }
            {
              options[1].slug === activeTab &&
              <>{children[1]}</>
            }
            {
              options[2].slug === activeTab &&
              <>{children[2]}</>
            }
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {

  };
};
const mapDispatchToProps = dispatch => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(ClusterGroupTabs);
